export default function getTimeDiffInDays(date1, date2) {
    const isNegative = date1 - date2 < 0 ? true : false
    const diff = Math.abs(date1 - date2)

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))

    if (isNegative) {
        return `${days} روز پیش`
    } else {
        return `${days} روز مانده`
    }
}
